import React, {useCallback, useState} from "react";
import api from "../../api/quiz";

export default function useQuizList() {
  const [isCreatingQuiz, setIsCreatingQuiz] = useState(false);
  const [isDeletingQuizs, setIsDeletingQuizs] = useState(false);

  const deleteQuizs = useCallback((idList) => {
    setIsDeletingQuizs(true);
    return Promise.all(idList.map(api.deleteQuiz()))
      .then(() => {
        setIsDeletingQuizs(false);
      }, () => {
        setIsDeletingQuizs(false);
      });
  }, [setIsDeletingQuizs]);

  const createQuiz = useCallback((data) => {
    setIsCreatingQuiz(true);
    return api.createQuiz(data).then(() => {
      setIsCreatingQuiz(false);
    }, () => {
      setIsCreatingQuiz(false);
    });
  }, [setIsCreatingQuiz]);

  return {
    createQuiz,
    deleteQuizs,
    isCreatingQuiz,
    isDeletingQuizs};
}
